import { render, staticRenderFns } from "./GeneralMenu.vue?vue&type=template&id=e5d79318&scoped=true&"
import script from "./GeneralMenu.vue?vue&type=script&lang=js&"
export * from "./GeneralMenu.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMenu.vue?vue&type=style&index=0&id=e5d79318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d79318",
  null
  
)

export default component.exports